import { render, staticRenderFns } from "./CashRegister.vue?vue&type=template&id=5a7d3d84&scoped=true&"
import script from "./CashRegister.vue?vue&type=script&lang=js&"
export * from "./CashRegister.vue?vue&type=script&lang=js&"
import style0 from "./CashRegister.vue?vue&type=style&index=0&id=5a7d3d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d3d84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VLazy,VSwitch})
